"use strict";

angular.module("exploitation").factory("ExploitRoutesPointsArretService",
	["$http", "ENV", "OkinaLeafletService", "leafletData", "$sanitize", function ($http, ENV, OkinaLeafletService, leafletData, $sanitize) {

	/**
	 * API
	 */
	return {
		/** HTTP REQUESTS **/
		/** MAP OBJECT **/
		displayAsTheCrowFliesVJ     : displayAsTheCrowFliesVJ,
		drawStopAreasFromPattern    : drawStopAreasFromPattern,
		cleanMap                    : cleanMap,
		getCurrentlyDrawnMarkerById : getCurrentlyDrawnMarkerById,
		popupRouteStopPointTemplate : popupRouteStopPointTemplate,
		STOP_POINT_MARKER_ID        : "stoppointmarker"
	};

	function displayStopArea( stopPoint, $scope, journeyPatternId, color, icon, draggable, zoomOn, index) {
		var latitude  = stopPoint.latitude;
		var longitude = stopPoint.longitude;

		if (latitude != null && typeof latitude !== "number") {
			latitude = parseFloat(latitude);
		}
		if (longitude != null && typeof longitude !== "number") {
			longitude = parseFloat(longitude);
		}

		if ( !color ) {
			color = "blue";
			if (stopPoint.isDeparture) {
				color = "green";
			} else if (stopPoint.isArrival) {
				color = "red";
			}
		}

		var leafletPoint = {
			lat: latitude,
			lng: longitude,
			id: stopPoint.id,
			spid: stopPoint.stop_point_id,
			draggable: draggable,
			focus : zoomOn == stopPoint.id,
			journeyPatternId: journeyPatternId,
			icon: {
				type: "extraMarker",
				icon: index ? "fa-number" : icon || "circle",
				number: index,
				markerColor: color,
				iconColor: stopPoint.isValidated ? "black" : "white"
			},
			popupMaxHeight: 200,
			message: popupRouteStopPointTemplate(stopPoint),
			getMessageScope: $scope ? function () {
				return $scope;
			} : null
		};

		OkinaLeafletService.createMarker( leafletPoint);

		if ( zoomOn == stopPoint.id ){
			OkinaLeafletService.setCenter( { lat: latitude, lng: longitude, zoom: 18}, true);
		}

		setTimeout( function(){
			getCurrentlyDrawnMarkerById( stopPoint.id, function ( marker) {
				if ( marker !== null) {
					marker.on( "mousedown", function(event){
						$scope.$apply(function () {
							$scope.data.selectedMapPointId = marker.options.id;
							$scope.enterEditButtonMode( stopPoint, true);
							$scope.data.currentStopPoint = stopPoint;
						});
					});
					marker.on("drag", function (event) {
						$scope.$apply(function () {
							$scope.data.currentStopPoint.longitude  = event.latlng.lng;
							$scope.data.currentStopPoint.latitude   = event.latlng.lat;
							$scope.data.currentStopPoint.isModified = true;
						});
					});
				}
			});
		}, 0);

	}

	function displayAsTheCrowFliesVJ( jp) {
		if ( !jp ) return;
		OkinaLeafletService.addPolyline( jp.stop_points.map(function (sa) {
			var latitude  = sa.latitude;
			var longitude = sa.longitude;
			if (latitude != null && typeof latitude !== "number") {
				latitude = parseFloat(latitude);
			}
			if (longitude != null && typeof longitude !== "number") {
				longitude = parseFloat(longitude);
			}
			return [latitude, longitude];
		}),
		{ directionnal: true, color : "#3040ff", weight: 2 },
		{ journeyPatternId: jp.id });
	}

	function popupRouteStopPointTemplate(feature) {
		var liste;
		if(feature.attributes === undefined){
			liste = feature.liaisons;
		}
		else{
			liste = feature.attributes.point.liaisons;
		}
		var liaisons = "";
		if(liste === null) {
			liaisons += "<br>- Aucune liaison de ligne -";
		}
		else if (liste.length === 0) {
			liaisons += "<br>Liaisons : <img style='height: 15px' src=\"../../assets/img/loading-orange.svg\"/><dt>";
		}
		else if(liste.length > 0){
			liaisons += "<br>Liaisons : <dt>";
			for (var i = 0; i < liste.length; i++) {
				var liaison = liste[i];
				liaisons = liaisons.concat("<dd>Reseau " + " : " + $sanitize(liaison.name) + "</dd>");
				for (var j = 0; j < liaison.lignes.length; j++) {
					var ligne = liaison.lignes[j];
					liaisons = liaisons.concat("<ul><li>Ligne " + $sanitize(ligne.number) + " : " + $sanitize(ligne.name) + "</li></ul>");
				}
			}
			liaisons.concat("</dt>");
		}

		if(feature.attributes === undefined){
			var parsedTemplate = "<div class='olPopup'>" +
				"<br>Point d'arrêt: <b>" + $sanitize(feature.name) + "</b>" +
				"<br>Nom commercial : " + $sanitize(feature.commercial_name) +
				liaisons +
				"</div>";
			return parsedTemplate;
		} else {
			var parsedTemplate = "<div class='olPopup'>" +
				"<br>Point d'arrêt: <b>" + $sanitize(feature.attributes.point.name) + "</b>" +
				"<br>Nom commercial : " + $sanitize(feature.attributes.point.commercial_name) +
				// "<br>Sens : " + feature.attributes.point.way +
				"</div>";
			return parsedTemplate;
		}
	}

	function drawStopAreasFromPattern( jp, $scope, color, icon, draggable, zoomOn)
	{
		if ( !jp ) return;
		for ( var key in jp.stop_points) {
			var stopPoint = jp.stop_points[key];
			if ( jp.departureStopPoint === stopPoint.stop_point_id ) {
				stopPoint.isDeparture = true;
			} else if ( jp.arrivalStopPoint === stopPoint.stop_point_id ) {
				stopPoint.isArrival = true;
			}
			displayStopArea( stopPoint, $scope, jp.id, color, icon, draggable, zoomOn, parseInt(key) + 1);
		}
	}

	function cleanMap( keepMarker)
	{
		if ( !keepMarker ) {
			OkinaLeafletService.markersFeatureGroup.eachLayer(function (markerLayer) {
				OkinaLeafletService.deleteMarker(markerLayer);
			});
		}
		OkinaLeafletService.deleteGeoJsonLayers();
	}

	/**
	 * Tool method
	 * Retrieve a drawn marker by its id in the map.
	 * The found marker is passed through a callback(marker) {}. null if none has been found.
	 * The marker's id has to be defined first during the creation of it
	 * @param id
	 * @param callback
	 */
	function getCurrentlyDrawnMarkerById(id, callback) {
		leafletData.getMap(OkinaLeafletService.getMapId()).then(
			function (map) {
				var foundLayer = null;
				map.eachLayer(function (layer) {
					if (layer.options.id === id) {
						foundLayer = layer;
					}
				});

				if (foundLayer !== null) {
					callback(foundLayer);
				} else {
					callback(null);
				}
			});
	}
}]);